


interface OrderRedatedIconProps {
	className?: string,
}


const OrderRedatedIcon = (props: OrderRedatedIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-order-redated-icon"
			className={`svg-inline--fa fa-custom-order-redated-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 333 512">
			<path fill="currentColor" d="m97.72,80.1c4.01,-23.23 21.63,-40.05 41.85,-40.05l48.06,0c20.23,0 38.05,17.02 41.85,40.25l3.6,21.23l40.65,0l-4.81,-28.04c-7.21,-42.65 -41.45,-73.49 -81.5,-73.49l-48.06,0c-39.85,0 -74.09,30.84 -81.3,73.49l-4.81,28.04l40.65,0l3.6,-21.23l0.2,-0.2z"/>
			<path fill="currentColor" d="m296.57,111.54l-260.33,0c-20.03,0 -36.25,16.22 -36.25,36.25l0,327.81c0,20.03 16.22,36.25 36.25,36.25l260.33,0c20.03,0 36.25,-16.22 36.25,-36.25l0,-327.81c0,-20.03 -16.22,-36.25 -36.25,-36.25zm-46.06,268.74l-135.17,0l0,18.42s-43.45,-27.63 -43.45,-27.63l43.86,-30.44l0,19.62l134.77,0c12.82,0 12.82,20.03 0,20.03zm-34.64,-93.52l-0.4,-17.22l-134.37,0c-12.82,0 -12.82,-20.03 0,-20.03l133.97,0l-0.4,-17.22l45.86,26.23l-44.26,28.04l-0.4,0.2z"/>
		</svg>
	);
};

export default OrderRedatedIcon;